import { sanitizeReturnTo } from '@/lib/auth/redirect'
import { create } from 'zustand'

/**
 * Auth modal UI state.
 *
 * 책임: 로그인/인증 관련 모달의 open/close/mode/returnTo.
 * `authStore` (사용자 세션) 와 분리된 UI state store.
 *
 * 확장: 향후 profile / settings 모달 등 추가 시 mode union 을 확장한다.
 *
 * GDEV-157: `returnTo` — 로그인 성공 후 복귀할 동일 오리진 path. 보호된 라우트
 * (AdminGuard 등) 에서 모달을 열 때 원 path 를 전달하면 LoginModal 이 성공 후
 * 해당 path 로 navigate. `sanitizeReturnTo` 로 open redirect 차단.
 */

export type AuthModalMode = 'signin'

interface AuthModalState {
  isOpen: boolean
  mode: AuthModalMode | null
  returnTo: string | null
  message: string | null
  open: (mode: AuthModalMode, returnTo?: string | null, message?: string | null) => void
  close: () => void
}

export const useAuthModalStore = create<AuthModalState>((set) => ({
  isOpen: false,
  mode: null,
  returnTo: null,
  message: null,
  open: (mode, returnTo, message) =>
    set({ isOpen: true, mode, returnTo: sanitizeReturnTo(returnTo), message: message ?? null }),
  close: () => set({ isOpen: false, mode: null, returnTo: null, message: null }),
}))
